import { useQueryClient } from '@tanstack/react-query'
import { ApiResponse } from '../../../types/api'
import { ParentUpdateData } from '../../../types/users'
import { useApiPostMutation } from '../useApi'

export const useParentUpdate = () => {
  const queryClient = useQueryClient()

  const mutation = useApiPostMutation<ApiResponse, ParentUpdateData>()

  const invalidateParentQueries = (parentId: number) => {
    queryClient.invalidateQueries({ queryKey: ['parentsList'] })
    queryClient.invalidateQueries({ queryKey: ['parentDetail', parentId] })
  }

  return {
    ...mutation,

    mutate: (
      data: ParentUpdateData,
      options?: Parameters<typeof mutation.mutate>[1]
    ) => {
      mutation.mutate(
        {
          url: '/users/update-parent',
          data,
        },
        {
          ...options,
          onSuccess: (...args) => {
            invalidateParentQueries(data.PARENT_ID)
            options?.onSuccess?.(...args)
          },
        }
      )
    },

    mutateAsync: async (data: ParentUpdateData) => {
      const result = await mutation.mutateAsync({
        url: '/users/update-parent',
        data,
      })
      invalidateParentQueries(data.PARENT_ID)
      return result
    },
  }
}
